export default function PHP_ob_get_clean() {
  return (
    <div>
      <h1>PHP_ob_get_clean</h1>
    </div>
  );
}
